export default "__VITE_ASSET__DE8q1og1__"